import { useMemo } from 'react';

// eslint-disable-next-line no-restricted-imports
import { useOrderGetEmployeesQuery } from 'api/generated/graphql';
import { useError } from 'api/helpers';
import { lodash } from 'helpers';

export const useOrderEmployees = () => {
  const { data, loading, error: apolloError } = useOrderGetEmployeesQuery();

  const error = useError(apolloError, false);

  const employees = useMemo(
    () =>
      lodash.compact(data?.employees?.list).map((admin) => ({
        id: admin.id,
        firstName: admin.firstName,
        lastName: admin.lastName,
        middleName: admin.middleName,
      })),
    [data?.employees?.list]
  );

  return {
    employees,
    loading,
    error,
  };
};
